import { render, staticRenderFns } from "./GlobalButton.vue?vue&type=template&id=eb976888&"
import script from "./GlobalButton.vue?vue&type=script&lang=ts&"
export * from "./GlobalButton.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalButton.vue?vue&type=style&index=0&id=eb976888&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports